<template>
  <div class="viq-related">
    <span class="viq-related__label">Related topics</span>
    <div class="viq-related__cards">
      <div
        v-for="(topic, i) in topics"
        :key="i"
        class="viq-related__card"
        @click="openTopic(topic)"
      >
        <span v-if="topic.type" class="viq-related__card-type">{{ topic.type }}</span>
        <h5 class="viq-related__card-title">{{ topic.title || topic }}</h5>
        <span v-if="topic.jurisdiction" class="viq-related__card-jurisdiction">
          {{ topic.jurisdiction }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ViqRelatedTopics",
  props: {
    topics: {
      type: Array,
      required: true,
    },
  },
  methods: {
    openTopic(topic) {
      if (topic.id || topic.article_id) {
        this.$store.dispatch("Viq/openSlideOut", topic);
      } else {
        // Ask as new question
        const text = typeof topic === "string" ? topic : topic.title;
        this.$store.dispatch("Viq/askQuestion", {
          question: text,
          conversationId: this.$store.state.Viq.activeConversation?.id || null,
          lensId: this.$store.state.Viq.activeLens?.id || null,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-related {
  margin-top: $viq-space-md;

  &__label {
    display: block;
    font-size: $viq-font-xs;
    font-weight: 600;
    color: $viq-text-secondary;
    margin-bottom: $viq-space-sm;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  &__cards {
    display: flex;
    gap: $viq-space-sm;
    overflow-x: auto;
    padding-bottom: $viq-space-xs;

    &::-webkit-scrollbar {
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.1);
      border-radius: 2px;
    }
  }

  &__card {
    flex-shrink: 0;
    width: 180px;
    padding: $viq-space-md;
    background: $viq-bg-primary;
    border: 1px solid $viq-border;
    border-radius: $viq-radius-md;
    cursor: pointer;
    transition: border-color $viq-transition-fast;

    &:hover {
      border-color: $viq-accent;
    }

    &-type {
      display: block;
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      color: $viq-accent;
      margin-bottom: $viq-space-xs;
    }

    &-title {
      font-size: $viq-font-sm;
      font-weight: 600;
      color: $viq-text-primary;
      margin: 0 0 $viq-space-xs;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    &-jurisdiction {
      font-size: 10px;
      color: $viq-text-secondary;
    }
  }
}
</style>
